<template>
  <div class="page">
    <div class="page__bd">
      <DownloadButton :caller="caller" :id="form.main.id"/>
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.pi_inoutno }}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="pi_custname">
            <label class="weui-form-preview__label">{{customLabel.pi_custname || "客户名称"}}</label>
            <em class="weui-form-preview__value">{{
              form.main.pi_custname
            }}</em>
          </div>
          <div class="weui-form-preview__item" slot="pi_contact">
            <label class="weui-form-preview__label">{{customLabel.pi_contact || "联系人"}}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.pi_contact }} {{ form.main.pi_tel }}
              <call-mobile :mobile="form.main.pi_tel"></call-mobile>
            </span>
          </div>
          <div class="weui-form-preview__item" slot="pi_address">
            <label class="weui-form-preview__label">{{customLabel.pi_address || "收货地址"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.pi_address
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pi_payments">
            <label class="weui-form-preview__label">{{customLabel.pi_payments || "收款方式"}}</label>
            <span class="weui-form-preview__value">
              {{ form.main.pi_payments }}
              <span v-if="form.main.pi_currency">{{
                form.main.pi_currency
              }}</span>
              <span v-if="form.main.pi_rate && form.main.pi_rate != 1"
                >/ {{ form.main.pi_rate }}</span
              >
            </span>
          </div>
          <div class="weui-form-preview__item" slot="pi_date">
            <label class="weui-form-preview__label">{{customLabel.pi_date || "退货日期"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.pi_date
            }}</span>
          </div>
          <custom-field :readOnly="true" :label="customLabel.pi_text1 || '自定义字段1'"
          v-model="form.main.pi_text1" slot="pi_text1" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pi_text2 || '自定义字段2'"
          v-model="form.main.pi_text2" slot="pi_text2" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pi_text3 || '自定义字段3'"
          v-model="form.main.pi_text3" slot="pi_text3" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pi_text4 || '自定义字段4'"
          v-model="form.main.pi_text4" slot="pi_text4" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pi_text5 || '自定义字段5'"
          v-model="form.main.pi_text5" slot="pi_text5" hidden="true" />
          <div class="weui-form-preview__item" slot="pi_seller" v-if="form.main.pi_seller" >
            <label class="weui-form-preview__label">业务员</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.pi_seller }}
              <call-mobile :em-id="form.main.pi_sellerid"></call-mobile>
            </span>
          </div>
          <div class="weui-form-preview__item" slot="pi_departmentname" v-if="form.main.pi_departmentname">
            <label class="weui-form-preview__label">事业部门</label>
            <span class="weui-form-preview__value"
              >{{ form.main.pi_departmentname }}
            </span>
          </div>
        </custom-layout>
      </div>

      <collapse class="form-preview weui-form-preview" :title="'明细（'+form.items.length+'条）'">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ item.pd_pdno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
          <div class="weui-form-preview__item" slot="pr_detail">
            <label class="weui-form-preview__label">{{customLabel.pr_detail || "产品名称"}}</label>
            <span class="weui-form-preview__value">{{
              item.productDTO.pr_detail
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_orispeccode" v-if="item.productDTO && item.productDTO.pr_orispeccode">
            <label class="weui-form-preview__label">{{customLabel.pr_detail || "型号"}}</label>
            <span class="weui-form-preview__value">{{
              item.productDTO.pr_orispeccode
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_spec" v-if="item.productDTO && item.productDTO.pr_spec">
            <label class="weui-form-preview__label">{{customLabel.pr_detail || "规格"}}</label>
            <span class="weui-form-preview__value">{{
              item.productDTO.pr_spec
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pd_whname">
            <label class="weui-form-preview__label">{{customLabel.pd_whname || "仓库"}}</label>
            <span class="weui-form-preview__value">{{ item.pd_whname }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pd_inqty">
            <label class="weui-form-preview__label">{{customLabel.pd_inqty || "数量"}}</label>
            <span class="weui-form-preview__value"
              >{{ item.pd_inqty }} {{ item.productDTO.pr_unit }}</span
            >
          </div>
          <div class="weui-form-preview__item" slot="pd_qty_extra" v-if="item.productDTO && item.productDTO.pr_unit_extra">
            <label class="weui-form-preview__label">{{customLabel.pd_qty_extra || "辅助数量"}}</label>
            <span class="weui-form-preview__value"
              >{{ item.pd_qty_extra }} {{ item.productDTO.pr_unit_extra }}</span
            >
          </div>
          <div class="weui-form-preview__item" slot="pd_price">
            <label class="weui-form-preview__label">{{customLabel.pd_price || "成本单价(元)"}}</label>
            <span class="weui-form-preview__value">{{
              numberFormat(item.pd_price,'#,##0.####')
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pd_price_extra" :hidden="!item.pd_price_extra">
            <label class="weui-form-preview__label">{{customLabel.pd_price_extra || "辅助单价(元)"}}</label>
            <span class="weui-form-preview__value">{{
              numberFormat(item.pd_price_extra,'#,##0.####')
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pd_netprice">
            <label class="weui-form-preview__label">{{customLabel.pd_netprice || "不含税单价(元)"}}</label>
            <span class="weui-form-preview__value">{{
              numberFormat(item.pd_netprice,'#,##0.####')
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pd_nettotal">
            <label class="weui-form-preview__label">{{customLabel.pd_nettotal || "不含税金额(元)"}}</label>
            <span class="weui-form-preview__value">{{
              numberFormat(item.pd_nettotal,'#,##0.00')
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pd_ordertotal">
            <label class="weui-form-preview__label">{{customLabel.pd_ordertotal || "含税金额(元)"}}</label>
            <span class="weui-form-preview__value">{{
              numberFormat(item.pd_ordertotal,'#,##0.00')
            }}</span>
          </div>
          <custom-field :readOnly="true" :label="customLabel.pd_text1 || '自定义字段1'"
            v-model="item.pd_text1" slot="pd_text1" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.pd_text2 || '自定义字段2'"
            v-model="item.pd_text2" slot="pd_text2" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.pd_text3 || '自定义字段3'"
            v-model="item.pd_text3" slot="pd_text3" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.pd_text4 || '自定义字段4'"
            v-model="item.pd_text4" slot="pd_text4" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.pd_text5 || '自定义字段5'"
            v-model="item.pd_text5" slot="pd_text5" hidden="true" />
          </custom-layout>
        </div>
      </collapse>

      <div class="form-preview weui-form-preview">
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="pi_nettotal">
            <label class="weui-form-preview__label">不含税金额（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{
              form.main.pi_nettotal
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pi_taxtotal">
            <label class="weui-form-preview__label">税额（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{
              form.main.pi_taxtotal
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pi_total">
            <label class="weui-form-preview__label">价税合计（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{
              form.main.pi_total
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.pi_remark" slot="pi_remark">
            <label class="weui-form-preview__label">备注</label>
            <span class="weui-form-preview__value">{{
              form.main.pi_remark
            }}</span>
          </div>
        </custom-layout>
      </div>
      <file-list v-model="form.main.pi_attach" />
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import FileList from "@/components/FileList.vue";
import form from "@/mixins/form.js";
import CallMobile from "@/components/button/CallMobile.vue";
import Collapse from "@/components/Collapse.vue";
import CustomField from "@/components/field/CustomField.vue";
import DownloadButton  from "@/components/button/Download.vue";

export default {
  mixins: [form],
  components: {
    CustomLayout,
    FileList,
    CallMobile,
    Collapse,
    CustomField,
    DownloadButton
  },
  data() {
    return {
      baseUrl: "/api/sale/prodinout",
      caller: "SaleIn",
      xtype: "sale-salein-formpanel",
    };
  },
};
</script>